import { useEffect, useState } from "react"
import { REZEPT_ENDPOINT } from "../../const/Endpoints"
import { STRAPI_API_KEY } from "../../const/Keys"
import { alenaxios } from "../../functions/alenaxios"

export function useRecipe(slug) {
    const [Data, setData] = useState(null)
    const [Error, setError] = useState(null)
    const [Loading, setLoading] = useState(false)


    useEffect(() => {
        (
            async function () {
                let endpoint = REZEPT_ENDPOINT + slug + "&populate=*"
                setError(false)
                setLoading(true)

                let config = {
                    method: 'get',
                    url: endpoint,
                    headers: {
                        'Authorization': `Bearer ${STRAPI_API_KEY}`
                    }
                };

                alenaxios(config)
                    .then(data => { setData(data || {}) })
                    .catch(() => setError(true))
                    .finally(() => setLoading(false))
            }
        )()
    }, [])

    return { Data, Loading, Error }
}